var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Devices",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.000000, 5.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "18.6666667 16.0316667 12.1616667 16.0316667 10.68 16.0316667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,5.34833333 L1.33333333,1.84833333 C1.31755809,0.843767101 2.11877771,0.0164369697 3.12333333,-3.73034936e-14 L22.21,-3.73034936e-14 C22.6927152,0.00789124779 23.1525171,0.207250884 23.4882212,0.554207635 C23.8239253,0.901164386 24.0080224,1.36728697 24,1.85 L24,9.33333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3333333,
    y1: 18.6666667,
    x2: 22.6666667,
    y2: 18.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.67333333,
    y1: 18.6666667,
    x2: 6.00666667,
    y2: 18.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 18.6666667,
    y: 9.33333333,
    width: 6.66666667,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.45661261e-13,
    y: 5.34833333,
    width: 10.68,
    height: 15.985,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9716667,
    y1: 18.6666667,
    x2: 10.68,
    y2: 18.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.6666667,
    y1: 16.0316667,
    x2: 12.67,
    y2: 18.6666667,
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.2fa55dcbc9dcadae3a92311436ae1e3e.svg";
export { ForwardRef as ReactComponent };